// extracted by css-extract-rspack-plugin
export default {"Timeline_Item":"TimelineRow-module__Timeline_Item__Do33LoK","Octicon":"TimelineRow-module__Octicon__Kfu7nZU"};